export const getCategories = (folders, menu) => {
  let categoriesTemp = [];
  if (folders.length === 0) {
    Object.keys(menu).map((menuValue) => {
      if (menuValue !== "metadata") {
        let menuValueTemp = menu[menuValue];
        if (menuValueTemp["metadata"] === "category") {
          categoriesTemp.push(menuValue);
        }
      }
      return 0;
    });
  } else {
    categoriesTemp = categoriesRecursion(folders, menu);
  }
  return categoriesTemp;
};
const categoriesRecursion = (folders, menu) => {
  let tempArray = [];
  if (folders.length === 0) {
    Object.keys(menu).map((menuValue) => {
      if (menuValue !== "metadata") {
        let menuValueTemp = menu[menuValue];
        if (menuValueTemp["metadata"] === "category") {
          tempArray.push(menuValue);
        }
      }
      return 0;
    });
    return tempArray;
  } else {
    let filteredFolders = folders.filter((value, index) => {
      return index !== 0;
    });
    return categoriesRecursion(filteredFolders, menu[folders[0]]);
  }
};
export const addCategoryUtil = (categoryName, menu, folders) => {
  const tempNewCategory = {
    metadata: "category",
  };
  if (Object.keys(menu).length === 0) {
    const hotelIDvalue = localStorage.getItem("hotelID");
    menu = {
      metadata: "menu",
      hotelID: hotelIDvalue,
    };
  }
  if (folders.length === 0) {
    menu = { ...menu, [categoryName]: tempNewCategory };
  } else {
    let filteredFolders = folders.filter((value, index) => {
      return index !== 0;
    });
    menu = {
      ...menu,
      [folders[0]]: addCategoryUtil(
        categoryName,
        menu[folders[0]],
        filteredFolders
      ),
    };
  }
  return menu;
};
export const addItem = (item, menu, folders) => {
  const tempMenuItem = {
    metadata: "item",
    price: item["price"],
    description: item["description"],
  };
  if (Object.keys(menu).length === 0) {
    const hotelIDvalue = localStorage.getItem("hotelID");
    menu = {
      metadata: "menu",
      hotelID: hotelIDvalue,
    };
  }
  if (folders.length === 0) {
    menu = { ...menu, [item["itemName"]]: tempMenuItem };
  } else {
    let filteredFolders = folders.filter((value, index) => {
      return index !== 0;
    });
    menu = {
      ...menu,
      [folders[0]]: addItem(item, menu[folders[0]], filteredFolders),
    };
  }
  return menu;
};
export const deleteCategory = (categoryDetails, categoryName, menu) => {
  var newObject = {};
  Object.keys(menu).map((index) => {});
};
export const deleteItem = (itemDetails, itemName, menu) => {
  var newObject = {};
  Object.keys(menu).map((index) => {
    if (index !== "metadata" && index !== "hotelID") {
      const tempObject = menu[index];
      if (tempObject["metadata"] === "category") {
        var newCategory = deleteItem(itemDetails, itemName, tempObject);
        newObject = { ...newObject, [index]: newCategory };
      } else if (tempObject["metadata"] === "item") {
        if (
          index !== itemName &&
          tempObject["price"] !== itemDetails["price"]
        ) {
          newObject = { ...newObject, [index]: tempObject };
        }
      }
    } else {
      newObject = { ...newObject, [index]: menu[index] };
    }
    return 0;
  });
  return newObject;
};
